import React from "react";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

function Loading() {
  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid align="center">
          <CircularProgress />
        </Grid>
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}

export default Loading;
